import type { AdminResourcesTranslationMessages } from './adminResourcesTranslationMessages';

export const adminResourcesLanguageFrench: AdminResourcesTranslationMessages = {
  labels: {
    name: 'Étiquettes',
    description: "Gérer les étiquettes pour le contrôle d'accès aux ressources",
    helperText: 'Liste des étiquettes pour ce record.',
    fields: {
      id: 'ID',
      delete: 'Supprimer',
      edit: 'Modifier',
      name: 'Nom',
      read: 'Lire',
      labels: { id: 'Étiquettes', name: 'Étiquettes' },
    },
    operations: {
      create: 'Créer une étiquette',
      delete: "Supprimer l'étiquette",
      edit: "Modifier l'étiquette",
    },
  },
  callflows: {
    name: 'Dialplans',
    fields: {
      id: 'ID',
      name: 'Nom',
      number: 'Numéro (optionnel)',
      priority: 'Priorité',
      description: 'Description',
      labels: { id: 'Étiquettes', name: 'Étiquettes' },
      entry: "Point d'entrée",
      is_backup: 'Sauvegarde',
      latest_callflow_version: 'Sauvegarde de',
      nodes: 'Nœuds',
      last_edit: 'Dernière modification',
      assigned_inbound_e164s: 'Inbound E164',
    },
    operations: {
      create: 'Créer un callflow',
      edit: 'Modifier le callflow',
      delete: 'Supprimer le callflow',
    },
    helperTexts: {
      number:
        "Numéro optionnel pour le flux d'appels. Si défini, peut être utilisé pour appeler le flux d'appels depuis les extensions internes via un code de fonction",
      priority:
        "L'ordre dans lequel le plan de numérotation sera exécuté. Plus le chiffre est bas, plus le plan sera exécuté tôt",
      assigned_inbound_e164s: "Numéros entrants qui exécuteront ce flux d'appels",
    },
  },
  mobility_configurations: {
    name: 'Configuration de mobilité',
    helperTexts: {
      owner: "Le propriétaire de l'enregistrement",
    },
    fields: {
      id: 'ID',
      name: 'Nom',
      description: 'Description',
      owner: 'Propriétaire',
    },
  },
  latest_callflow_version: {
    name: 'Backup du Dialplan',
  },
  carrier_mappings: {
    name: 'Mappages des carrières',
    fields: {
      id: 'ID',
      name: 'Nom',
      description: 'Description',
      interface: 'Interface',
      rules: 'Règles',
      match_property: 'Correspondance propriété',
      set_property: 'Définir propriété',
      labels: { id: 'Étiquettes', name: 'Étiquettes' },
      enabled: 'Activé',
    },
  },
  user_mappings: {
    name: 'Mappages des utilisateurs',
    fields: {
      id: 'ID',
      name: 'Nom',
      interface: 'Interface',
      description: 'Description',
      enabled: 'Activé',
      labels: { id: 'Étiquettes', name: 'Étiquettes' },
      match_property: 'Correspondance propriété',
      set_property: 'Définir propriété',
      rules: 'Règles',
    },
    user_inbound: 'Mappage entrant',
    user_outbound: 'Mappage sortant',
    all: 'Tous',
  },
  mappings: {
    name: 'Mappages',
    fields: {
      interface: 'Interface',
      id: 'ID',
      name: 'Nom',
      description: 'Description',
      enabled: 'Activé',
      match_property: 'Correspondance propriété',
      enum_match_property: {
        caller_id_number: 'ID numéro appelant',
        caller_id_name: 'ID nom appelant',
        called_id_name: 'ID nom appelé',
        called_id_number: 'ID numéro appelé',
        remote_network_addr: 'Adresse réseau distante',
      },
      set_property: 'Définir propriété',
      enum_set_property: {
        caller_id_number: 'ID numéro appelant',
        caller_id_name: 'ID nom appelant',
        called_id_name: 'ID nom appelé',
        called_id_number: 'ID numéro appelé',
        remote_network_addr: 'Adresse réseau distante',
      },
      rules: 'Règles',
      labels: { id: 'Étiquettes', name: 'Étiquettes' },
      match_rule: 'Règle de correspondance',
      set_rule: 'Définir la règle',
    },
    operations: {
      create: 'Créer mappage',
      edit: 'Modifier mappage',
      delete: 'Supprimer mappage',
      sections: {
        details: 'Détails',
      },
    },
    helperTexts: {
      match_property: 'Appeler la propriété à utiliser pour les règles de correspondance',
      set_property: 'Appeler la propriété à définir en cas de correspondance',
      rules: "Match/Set rules, traitées dans l'ordre, la première gagne",
    },
  },
  queues: {
    name: "Files d'attente",
    fields: {
      calendar: 'Calendrier',
      call_recording_conf_id: 'Configuration enregistrement des appels',
      callback_announce: 'Annonce',
      callback_book_announce: 'Annonce de réservation',
      callback_success_announce: 'Annonce de succès',
      customsound: 'Son personnalisé',
      description: 'Description',
      labels: { id: 'Étiquettes', name: 'Étiquettes' },
      id: 'ID',
      name: 'Nom',
      type: 'Type',
      number: 'Numéro',
      settings: {
        alarm_threshold: "Seuil d'alarme",
        announce_agent: "Annoncer l'agent",
        announce_frequency: "Fréquence d'annonce",
        announce_position: "Position d'annonce",
        announce_waiting: "Attendre l'annonce",
        busy_delay_time: 'Temps de retard occupé',
        call_timeout: "Délai d'appel",
        callback_caller_id_number: "Numéro de l'appelant pour rappel",
        callback_caller_number_regex: "Expression régulière du numéro de l'appelant pour rappel",
        callback_delay: 'Retard de rappel',
        callback_enabled: 'Rappel activé',
        callback_retention: 'Conservation du rappel',
        callback_retries: 'Nombre de tentatives de rappel',
        callback_timeout: 'Délai de rappel',
        callback_username: "Nom d'utilisateur pour rappel",
        callback_wait_time: "Temps d'attente du rappel",
        continue_on_answer: 'Continuer après réponse',
        continue_on_max_waiters: 'Continuer après attente maximale',
        daily_reset_stats: 'Réinitialisation quotidienne des statistiques',
        daily_reset_stats_time: 'Heure de réinitialisation quotidienne des statistiques',
        exitkey: 'Clé de sortie',
        ignore_unavail: "Ignorer l'indisponibilité",
        max_exten: 'Max exten',
        max_wait_time: "Temps d'attente maximum",
        no_answer_delay_time: 'Temps de retard sans réponse',
        reject_delay_time: 'Temps de retard de rejet',
        service_level: 'Niveau de service',
        skip_empty: 'Passer vide',
        weight: 'Poid',
        wrap_up_time: 'Temps de conclusion',
      },
      soundfile: 'Fichier son',
      strategy: 'Stratégie',
      strategies: {
        all: 'Appeler tout le monde',
        rr: 'Round Robin',
        fewest_calls: 'Moins d’appels',
        rr_memory: 'Round Robin avec mémoire',
        mi: 'Le moins récent',
      },
    },
    operations: {
      create: "Créer une file d'attente",
      edit: "Modifier une file d'attente",
      delete: "Supprimer une file d'attente",
      sections: {
        details: 'Détails',
        callbacks: 'Callbacks',
        settings: 'Paramètres',
      },
    },
    helperTexts: {
      number: "Numéro de la file d'attente",
      strategy: 'Comment un appel est distribué aux agents',
      callback_announce: "Le fichier son de l'annonce du rappel",
      callback_book_announce: 'Fichier sonore de la confirmation du livre de rappel',
      callback_success_announce: 'Fichier sonore du rappel réussi',
      settings: {
        alarm_threshold: "Nombre d'appels entraînant l'affichage d'une alerte",
        announce_agent:
          "Lorsque l'agent répond à l'appel, un message est diffusé pour annoncer le numéro d'identification de l'opérateur qui répond",
        announce_frequency: "Fréquence en secondes des annonces dans la file d'attente",
        announce_position: "Diffusion régulière d'un message informant l'appelant de sa position actuelle",
        announce_waiting: "Diffusion régulière d'un message informant l'appelant du temps d'attente estimé",
        busy_delay_time: "Délai d'occupation en secondes",
        call_timeout: "Durée de l'appel en secondes",
        callback_caller_id_number: "Numéro d'identification de l'appelant utilisé pour passer l'appel sortant",
        callback_caller_number_regex:
          "Regex utilisée pour valider le numéro de rappel alternatif composé par l'appelant",
        callback_delay: 'Délai avant de réessayer un rappel en secondes',
        callback_enabled: 'Activation du service de rappel',
        callback_retention: "Durée, en heures, avant de supprimer un rappel réservé de la file d'attente",
        callback_retries: 'Nombre de tentatives de rappel',
        callback_timeout: "Nombre de secondes de sonnerie pour un rappel de file d'attente",
        callback_username: "Nom d'utilisateur utilisé pour passer l'appel sortant",
        callback_wait_time:
          "Après le temps d'attente spécifié dans la file d'attente, l'appelant peut maintenant appuyer sur une touche et demander un rappel",
        continue_on_answer:
          "Continuer ou non à suivre le flux d'appels lorsqu'un appel est terminé après avoir été pris par un agent",
        continue_on_max_waiters:
          "Continuer ou non à suivre le flux d'appels lorsqu'un appel rejoint une file d'attente et que le nombre maximum d'appels configuré est atteint",
        daily_reset_stats: 'Active la réinitialisation quotidienne des statistiques en temps réel',
        daily_reset_stats_time:
          'Heure de la journée à laquelle les statistiques en temps réel doivent être réinitialisées',
        exitkey:
          "Permet ou non à l'appelant de quitter la file d'attente en appuyant sur la touche 0 et de continuer à suivre le flux d'appels",
        ignore_unavail: 'Ignorer le statut injoignable des agents',
        max_exten:
          "Nombre maximal de personnes en attente dans la file d'attente. Une valeur de 0 signifie que le nombre de personnes est illimité",
        max_wait_time:
          "Temps d'attente en secondes d'un appel dans la file d'attente avant qu'il ne soit acheminé vers le bloc suivant",
        no_answer_delay_time: "Délai d'attente sans réponse en secondes",
        reject_delay_time: 'Délai de rejet en secondes',
        service_level:
          "Statistiques sur le niveau de service. Une valeur de 0 signifie qu'il n'y a pas de statistiques",
        skip_empty: "Sauter la file d'attente sans agents enregistrés",
        weight:
          "Par rapport aux autres files d'attente, les valeurs de poids les plus élevées ont la priorité sur les agents disponibles lorsque le même agent est inclus dans plus d'une file d'attente. Une valeur de 0 désactive cette fonction",
        wrap_up_time: "Temps d'attente en secondes",
      },
    },
  },
  agents: {
    name: 'Agents',
    type: 'Type',
    fields: {
      group: 'Groupe',
      user: 'Utilisateur',
      labels: { id: 'Labels', name: 'Labels' },
      name: 'Nom',
      queue: "File d'attente",
      settings: {
        busy_delay_time: 'Temps de retard occupé',
        call_timeout: "Délai d'appel",
        initial_paused: 'Initialement en pause',
        no_answer_delay_time: 'Temps de retard sans réponse',
        position: 'Position',
        reject_delay_time: 'Temps de retard de rejet',
        wrap_up_time: 'Temps de conclusion',
      },
    },
    operations: {
      create: 'Créer un agent',
      edit: 'Modifier un agent',
      delete: 'Supprimer un agent',
      assign_agents: 'Attribuer des agents',
      sections: {
        details: "Détails de l'agent",
        settings: "Paramètres de l'agent",
      },
    },
    helperTexts: {
      bulkAssignLabels: 'Liste des étiquettes à attribuer aux agents nouvellement ajoutés',
      settings: {
        busy_delay_time:
          "Nombre de secondes à attendre avant qu'un appel ne soit acheminé vers un agent si une tonalité occupée est détectée sur le téléphone de l'agent",
        call_timeout: 'Nombre de secondes pendant lesquelles un agent sonne',
        no_answer_delay_time:
          "Nombre de secondes à attendre avant qu'un appel soit acheminé vers un agent s'il ne répond pas",
        position: "Position de l'agent dans la file d'attente",
        reject_delay_time:
          "Nombre de secondes d'attente avant qu'un appel ne soit acheminé vers un agent si une tonalité de rejet est détectée sur le téléphone de l'agent",
        wrap_up_time:
          "Nombre de secondes dont dispose l'agent pour effectuer le travail de suivi de l'appel une fois la conversation terminée",
      },
    },
  },
  'presence/users': {
    name: 'Utilisateurs de présence',
    fields: {
      id: 'ID',
      firstname: 'Prénom',
      lastname: 'Nom de famille',
      middlename: 'Deuxième prénom',
      username: 'Nom d utilisateur',
    },
  },
  queue_measurements: {
    name: "Statistiques de file d'attente",
    fields: {
      id: 'ID',
      name: 'Nom',
      description: 'Description',
      labels: { id: 'Étiquettes', name: 'Étiquettes' },
    },
  },
  call_reports: {
    name: "Rapports d'appel",
  },
  call_recordings: {
    name: "Enregistrements d'appels",
    fields: {
      caller_id_name: "Nom de l'appelant",
      caller_id_number: "Numéro de l'appelant",
      called_id_name: "Nom de l'appelé",
      called_id_number: "Numéro de l'appelé",
      start_time: 'Début',
      end_time: 'Fin',
      account: 'Compte',
      id: 'ID',
      recording_uuid: 'UUID enregistrement',
      url: 'URL',
      user_id: 'ID utilisateur',
      status: 'Statut',
      labels: { name: 'Étiquettes', id: "ID d'étiquette" },
    },
    statuses: {
      recording: 'En cours',
      completed: 'Terminé',
      failed: 'Échoué',
    },
    unavailable: 'Enregistrement indisponible',
  },
  'me/call_recordings': {
    name: "Enregistrements d'appels",
  },
  call_recording_confs: {
    name: "Configurations d'enregistrement des appels",
    fields: {
      name: 'Nom',
      description: 'Description',
      soundfile_id: "Fichier sonore d'annonce",
      labels: { id: 'Étiquettes', name: 'Étiquettes' },
      call_recording_labels: "Étiquettes d'enregistrement",
      settings: {
        announce: "Jouer l'annonce",
        bip: 'Jouer un bip',
        asr: 'Activer la reconnaissance vocale',
        format_file: "Format d'enregistrement",
        name_file: 'Modèle de nom de fichier',
        hash_file: "Hacher le fichier d'enregistrement",
        crypto: "Chiffrer l'enregistrement",
        crypto_password: 'Mot de passe de chiffrement',
        crypto_password_confirmation: 'Confirmation du mot de passe',
        ek: 'Clé de chiffrement',
        ek_recovery: 'Activer la récupération de clé',
      },
      types: {
        in: 'Entrant',
        outbound_local: 'Sortant local',
        outbound_external: 'Sortant externe',
        onetouch: 'Un touche',
      },
    },
    operations: {
      create: "Créer une configuration d'enregistrement",
      edit: "Modifier la configuration d'enregistrement",
      delete: "Supprimer la configuration d'enregistrement",
      sections: {
        details: 'Détails',
        settings: 'Paramètres',
        users: 'Utilisateurs',
      },
      manage_users: 'Gérer les affectations utilisateur',
    },
  },
  user_call_recording_confs: {
    name: "Affectations d'enregistrement utilisateur",
    fields: {
      id: 'ID',
      type: "Type d'appel",
      user: 'Utilisateur',
    },
    confirmDelete: {
      title: "Supprimer l'affectation d'enregistrement",
      content: "Êtes-vous sûr de vouloir supprimer cette affectation d'enregistrement ?",
    },
  },
  queue_call_sessions: {
    name: "Sessions d'appel en file",
    fields: {
      id: 'ID',
      answer_time: 'Durée de réponse (s)',
      answer_ts: 'Horodatage de réponse',
      answered_by: 'Répondu par',
      caller_id_name: 'Nom identifiant appelant',
      caller_id_number: 'Numéro identifiant appelant',
      called_id_number: 'Numéro identifiant appelé',
      first_queue: 'Première file',
      final_queue: 'File finale',
      final_exit_cause: 'Cause de sortie finale',
      first_join_ts: 'Heure de première entrée',
      last_leave_ts: 'Heure de dernière sortie',
      total_time: 'Temps total en file (s)',
      total_queues: 'Files traversées',
      labels: { id: 'Étiquettes', name: 'Étiquettes' },
      actions: 'Actions',
    },
    actions: {
      viewQueueEvents: 'Événements de file',
      viewAgentEvents: 'Événements agent',
    },
  },
  queue_call_session_events: {
    name: "Événements de session d'appel en file",
    fields: {
      id: 'ID',
      caller_id_name: 'Nom identifiant appelant',
      caller_id_number: 'Numéro identifiant appelant',
      called_id_number: 'Numéro identifiant appelé',
      queue_name: 'Nom de la file',
      join_ts: "Heure d'entrée",
      leave_ts: 'Heure de sortie',
      exit_cause: 'Cause de sortie',
      answered_by: 'Répondu par',
      answer_ts: 'Heure de réponse',
      answer_time: 'Durée de réponse (s)',
      labels: { id: 'Étiquettes', name: 'Étiquettes' },
    },
  },
  queue_call_session_agent_events: {
    name: 'Événements agent de session en file',
    fields: {
      id: 'ID',
      agent_name: 'Nom de l’agent',
      caller_id_name: 'Nom identifiant appelant',
      queue_name: 'Nom de la file',
      originate_ts: 'Heure d’origine',
      answer_ts: 'Heure de réponse',
      end_ts: 'Heure de fin',
      exit_cause: 'Cause de sortie',
      answer_time: 'Durée de réponse (s)',
      caller_id_number: 'Numéro identifiant appelant',
      called_id_number: 'Numéro identifiant appelé',
      group_name: 'Nom du groupe',
      labels: { id: 'Étiquettes', name: 'Étiquettes' },
    },
  },
  auth_providers: {
    name: 'Fournisseur d’authentification',
    description: 'Afficher et gérer les fournisseurs d’authentification',
    fields: {
      name: 'Nom',
      description: 'Description',
      client_id: 'ID client',
      client_secret: 'Secret client',
      configuration_endpoint: 'URL de configuration',
      enabled: 'Activé',
      issuer: 'Émetteur',
      scopes: 'Scopes',
      labels: { id: 'Étiquettes', name: 'Étiquettes' },
      button_text: 'Libellé personnalisé pour le bouton de connexion (ex. Se connecter avec Google)',
      policies: { login: 'Activer la connexion', token_exchange: 'Activer l’échange de jetons externe' },
    },
    operations: {
      create: 'Créer un fournisseur',
      edit: 'Modifier le fournisseur',
      delete: 'Supprimer le fournisseur',
      sections: {
        providerConfig: 'Configuration',
        advanced: 'Advanced',
      },
    },
    configEpValidation: {
      invalid: 'Point de terminaison non valide',
      valid: 'Point de terminaison valide',
    },
    labels: {
      enabled: 'Activé',
      loginEnabled: 'Connexion autorisée',
      tokenExchangeEnabled: 'Échange de jetons autorisé',
    },
  },
  oauth_applications: {
    name: 'Applications OAuth',
    description: 'Afficher et gérer les applications OAuth',
    fields: {
      name: 'Nom',
      client_id: 'ID client',
      client_secret: 'Secret client',
      redirect_uri: 'URI de redirection',
      scopes: 'Scopes',
      enabled: 'Activé',
      labels: { id: 'Étiquettes', name: 'Étiquettes' },
    },
    helperTexts: {
      redirect_uri:
        "URI absolue vers laquelle le serveur d'autorisation redirigera l'agent utilisateur après avoir accordé ou refusé l'accès.",
    },
    operations: {
      create: 'Créer une application',
      edit: "Modifier l'application",
      delete: "Supprimer l'application",
      sections: {
        applicationConfig: "Configuration de l'application",
      },
    },
    labels: {
      enabled: 'Activé',
    },
  },
  call_sessions: {
    name: 'CDR',
    fields: {
      id: 'ID',
      caller_id_number: 'Numéro ID appelant',
      caller_id_name: 'Nom ID appelant',
      called_id_number: 'Numéro ID appelé',
      called_id_name: 'Nom ID appelé',
      answer_time: 'Heure de réponse',
      creation_time: 'Heure de création',
      hangup_cause: 'Cause de raccrochage',
      hangup_time: 'Heure de raccrochage',
      account: 'Compte',
      called_account: 'Compte appelé',
      called: 'Appelé',
      caller: 'Appelant',
      labels: { id: 'Étiquettes', name: 'Étiquettes' },
      hangupCauses: {
        UNALLOCATED_NUMBER: 'Numéro non attribué',
        NO_ROUTE_TRANSIT_NET: 'Aucune route via le réseau de transit',
        NO_ROUTE_DESTINATION: 'Aucune route vers la destination',
        CHANNEL_UNACCEPTABLE: 'Canal inacceptable',
        CALL_AWARDED_DELIVERED: 'Appel attribué et délivré',
        NORMAL_CLEARING: 'Libération normale',
        USER_BUSY: 'Utilisateur occupé',
        NO_USER_RESPONSE: 'Pas de réponse de l’utilisateur',
        NO_ANSWER: 'Pas de réponse',
        SUBSCRIBER_ABSENT: 'Abonné absent',
        CALL_REJECTED: 'Appel rejeté',
        NUMBER_CHANGED: 'Numéro modifié',
        REDIRECTION_TO_NEW_DESTINATION: 'Redirection vers une nouvelle destination',
        EXCHANGE_ROUTING_ERROR: 'Erreur de routage de l’échange',
        DESTINATION_OUT_OF_ORDER: 'Destination hors service',
        INVALID_NUMBER_FORMAT: 'Format de numéro invalide',
        FACILITY_REJECTED: 'Fonctionnalité rejetée',
        RESPONSE_TO_STATUS_ENQUIRY: 'Réponse à la demande de statut',
        NORMAL_UNSPECIFIED: 'Non spécifié',
        NORMAL_CIRCUIT_CONGESTION: 'Congestion du circuit',
        NETWORK_OUT_OF_ORDER: 'Réseau hors service',
        NORMAL_TEMPORARY_FAILURE: 'Défaillance temporaire normale',
        SWITCH_CONGESTION: 'Congestion du commutateur',
        ACCESS_INFO_DISCARDED: 'Informations d’accès rejetées',
        REQUESTED_CHAN_UNAVAIL: 'Canal demandé non disponible',
        PRE_EMPTED: 'Préempté',
        FACILITY_NOT_SUBSCRIBED: 'Fonctionnalité non souscrite',
        OUTGOING_CALL_BARRED: 'Appel sortant interdit',
        INCOMING_CALL_BARRED: 'Appel entrant interdit',
        BEARERCAPABILITY_NOTAUTH: 'Capacité de transport non autorisée',
        BEARERCAPABILITY_NOTAVAIL: 'Capacité de transport non disponible',
        SERVICE_UNAVAILABLE: 'Service indisponible',
        BEARERCAPABILITY_NOTIMPL: 'Capacité de transport non implémentée',
        CHAN_NOT_IMPLEMENTED: 'Canal non implémenté',
        FACILITY_NOT_IMPLEMENTED: 'Fonctionnalité non implémentée',
        SERVICE_NOT_IMPLEMENTED: 'Service non implémenté',
        INVALID_CALL_REFERENCE: 'Référence d’appel invalide',
        INCOMPATIBLE_DESTINATION: 'Destination incompatible',
        INVALID_MSG_UNSPECIFIED: 'Message non spécifié',
        MANDATORY_IE_MISSING: 'IE obligatoire manquant',
        MESSAGE_TYPE_NONEXIST: 'Type de message inexistant',
        WRONG_MESSAGE: 'Message incorrect',
        IE_NONEXIST: 'IE inexistant',
        INVALID_IE_CONTENTS: 'Contenu IE invalide',
        WRONG_CALL_STATE: 'État d’appel incorrect',
        RECOVERY_ON_TIMER_EXPIRE: 'Récupération à l’expiration du minuteur',
        MANDATORY_IE_LENGTH_ERROR: 'Erreur de longueur IE obligatoire',
        PROTOCOL_ERROR: 'Erreur de protocole',
        INTERWORKING: 'Interfonctionnement',
        SUCCESS: 'Succès',
        ORIGINATOR_CANCEL: 'Annulation par l’initiateur',
        CRASH: 'Crash',
        SYSTEM_SHUTDOWN: 'Arrêt du système',
        LOSE_RACE: 'Perte de course',
        MANAGER_REQUEST: 'Demande du gestionnaire',
        BLIND_TRANSFER: 'Transfert aveugle',
        ATTENDED_TRANSFER: 'Transfert assisté',
        ALLOTTED_TIMEOUT: 'Timeout alloué',
        USER_CHALLENGE: 'Challenge utilisateur',
        MEDIA_TIMEOUT: 'Timeout média',
        PICKED_OFF: 'Appel intercepté',
        USER_NOT_REGISTERED: 'Utilisateur non enregistré',
        PROGRESS_TIMEOUT: 'Timeout de progression',
        INVALID_GATEWAY: 'Passerelle invalide',
        GATEWAY_DOWN: 'Passerelle indisponible',
        INVALID_URL: 'URL invalide',
        INVALID_PROFILE: 'Profil invalide',
        NO_PICKUP: 'Aucune prise en charge',
        SRTP_READ_ERROR: 'Erreur lecture SRTP',
        BOWOUT: 'Sortie de l’appel',
        BUSY_EVERYWHERE: 'Occupé partout',
        DECLINE: 'Appel refusé',
        DOES_NOT_EXIST_ANYWHERE: 'N’existe pas',
        NOT_ACCEPTABLE: 'Non acceptable',
        UNWANTED: 'Indésirable',
        NO_IDENTITY: 'Identité absente',
        BAD_IDENTITY_INFO: 'Informations d’identité incorrectes',
        UNSUPPORTED_CERTIFICATE: 'Certificat non supporté',
        INVALID_IDENTITY: 'Identité invalide',
        STALE_DATE: 'Date périmée',
        REJECT_ALL: 'Tout refuser',
      },
    },
    info: {
      title: "Détails de la session d'appel",
    },
    errors: {
      loadFailed: "Impossible de charger les détails de la session d'appel.",
    },
  },
  call_session_events: {
    name: "Événements de session d'appel",
    fields: {
      id: 'ID',
      detailsLabel: 'Détails',
      details: {
        account: 'Compte',
        action: 'Action',
        answer_time: 'Heure de réponse',
        called_account: 'Compte appelé',
        create_time: 'Heure de création',
        hangup_time: 'Heure de raccrochage',
        type: 'Type',
        to: 'À',
        transferor: 'Transféreur',
        description: 'Description',
        mobility_username: "Nom d'utilisateur de mobilité",
        digit: 'Chiffre',
        called_number: 'Numéro appelé',
        reason: 'Raison',
        result: 'Résultat',
        carrier_name: 'Nom du transporteur',
      },
      parent_channel_id: 'ID du canal parent',
      channel_id: 'ID du canal',
      ts_event: "Heure de l'événement",
      labels: { id: 'Étiquettes', name: 'Étiquettes' },
    },
    viewModes: {
      hierarchy: 'Cartes détaillées',
      tree: 'Vue arborescente',
    },
    summary: {
      channelTitle: 'Canal %{channel}',
      parent: 'Canal parent',
      parentFallback: 'Canal racine',
      unknownChannel: 'Canal inconnu',
      firstEvent: 'Premier événement',
      lastEvent: 'Dernier événement',
      eventCount: '%{smart_count} événement |||| %{smart_count} événements',
    },
    event: {
      timestamp: 'Horodatage',
      noDetails: 'Aucun détail supplémentaire',
      unknownType: 'Type inconnu',
    },
    types: {
      agent_call: 'Appel agent',
      user_call: 'Appel utilisateur',
      outbound_call: 'Appel sortant',
      queue: 'File',
      mobility: 'Mobilité',
      call_me: 'Rappel',
      calendar: 'Calendrier',
      presence_router: 'Routeur de présence',
      disconnect: 'Déconnexion',
    },
    status: {
      answered: 'Répondu',
      unanswered: 'Non répondu',
    },
    empty: {
      title: 'Aucun événement pour le moment',
      description: "Les activités de la session d'appel apparaîtront ici dès qu'elles seront disponibles.",
    },
    errors: {
      loadFailed: "Impossible de charger les événements de la session d'appel.",
    },
    toggleAdvanced: 'Afficher les informations avancées',
  },
  encryption_configurations: {
    name: 'Clés de chiffrement du stockage',
    fields: {
      id: 'ID',
      domain_id: 'Domaine',
      name: 'Nom',
      description: 'Description',
      enabled: 'Activé',
      labels: { id: 'Étiquettes', name: 'Étiquettes' },
      metadata: {
        type: 'Type',
      },
    },
    operations: {
      create: 'Créer une configuration de chiffrement',
      delete: 'Supprimer une configuration de chiffrement',
      edit: 'Modifier une configuration de chiffrement',
      sections: {
        details: 'Détails',
        configuration: 'Configuration',
      },
    },
    helperTexts: {
      enabled: 'Une seule configuration peut être activée à la fois.',
    },
  },
  storage_configurations: {
    name: 'Configurations de stockage externe',
    fields: {
      id: 'ID',
      domain_id: 'Domaine',
      name: 'Nom',
      description: 'Description',
      enabled: 'Activé',
      labels: { id: 'Étiquettes', name: 'Étiquettes' },
      metadata: {
        type: 'Type',
        endpoint_scheme: 'Schéma du point de terminaison',
        endpoint_host: 'Hôte du point de terminaison',
        endpoint_port: 'Port du point de terminaison',
        region: 'Région',
        bucket: 'Compartiment',
        access_key: "Clé d'accès",
        secret_key: 'Clé secrète',
        ssl_verify: 'Vérifier le certificat SSL',
      },
    },
    operations: {
      create: 'Créer une configuration de stockage',
      delete: 'Supprimer une configuration de stockage',
      edit: 'Modifier une configuration de stockage',
      sections: {
        details: 'Détails',
        s3_configuration: 'Configuration S3',
      },
    },
    helperTexts: {
      enabled: 'Une seule configuration peut être activée à la fois.',
      immutable: 'Ces champs ne pourront pas être modifiés après enregistrement.',
    },
  },
};
